import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { loginUser } from "actions/auth/actions";
import Spinner from "views/lib/components/Spinner";

const Login = (props) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [validated, setValidated] = useState(false);

    const onSubmit = (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
        } else {
            props.loginUser({
                username,
                password
            });
        }
    };

    return (
        <div className="row w-100">
            <div className="col-12 col-md-6 m-auto">
                <h1 className="display-4 text-center">
                    Log In
                </h1>
                <Form
                    noValidate
                    validated={validated}
                    onSubmit={e => onSubmit(e)}
                    className="position-relative"
                >
                    {!props.loading || <Spinner/>}
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <Form.Control
                            id="username"
                            type="text"
                            placeholder="Username"
                            name="username"
                            autoComplete="username"
                            value={username}
                            onChange={(ev) => setUsername(ev.target.value)}
                            aria-describedby="inputGroupPrepend"
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Please input username.
                        </Form.Control.Feedback>
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <Form.Control
                            id="password"
                            type="password"
                            placeholder="Password"
                            autoComplete="current-password"
                            name="password"
                            value={password}
                            onChange={(ev) => setPassword(ev.target.value)}
                            aria-describedby="inputGroupPrepend"
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Please input password.
                        </Form.Control.Feedback>
                    </div>

                    <div className="text-right">
                        <button type="submit" className="btn btn-success">
                            Login
                        </button>
                    </div>

                </Form>
            </div>
        </div>
    );
};

/*
class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: "",
            password: "",
            validated: false,
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(e) {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            this.setState({
                validated: true
            });
        } else {
            const {
                username,
                password
            } = this.state;
            this.props.loginUser({
                username,
                password
            });
        }
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {
        const {
            validated
        } = this.state;

        return (
            <div className="row w-100">
                <div className="col-12 col-md-6 m-auto">
                    <h1 className="display-4 text-center">
                        Log In
                    </h1>
                    <Form
                        noValidate
                        validated={validated}
                        onSubmit={e => this.onSubmit(e)}
                        className="position-relative"
                    >
                        {!this.props.loading || <Spinner/>}
                        <div className="form-group">
                            <label htmlFor="username">Username</label>
                            <Form.Control
                                id="username"
                                type="text"
                                placeholder="Username"
                                name="username"
                                autoComplete="username"
                                value={this.state.username}
                                onChange={this.onChange}
                                aria-describedby="inputGroupPrepend"
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Please input username.
                            </Form.Control.Feedback>
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <Form.Control
                                id="password"
                                type="password"
                                placeholder="Password"
                                autoComplete="current-password"
                                name="password"
                                value={this.state.password}
                                onChange={this.onChange}
                                aria-describedby="inputGroupPrepend"
                                required
                            />
                            <Form.Control.Feedback type="invalid">
                                Please input password.
                            </Form.Control.Feedback>
                        </div>

                        <div className="text-right">
                            <button type="submit" className="btn btn-success">
                                Login
                            </button>
                        </div>

                    </Form>
                </div>
            </div>
        );
    }
}
*/

Login.propTypes = {
    loginUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
});

const mapStateToDispatch = dispatch => ({
    loginUser: bindActionCreators(loginUser, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(Login);



// WEBPACK FOOTER //
// ./src/views/pages/login.js